export const ESSENTIALS_GET_ARTICLES_QUERY = `query getArticles($site:[String], $id:[QueryArgument]) {
    entries(
        section: "articles"
        id: $id
        site: $site
    ) {
        ... on articles_articles_Entry {
            uri
            title
            id
            readTime: text
            contentFormat
            contentType
            image { url }
            category {
                slug
                title
                type: categoryType
                parent {
                    slug
                    title
                    type: categoryType
                }
            }
        }
    }
}`

export const ESSENTIALS_GET_CATEGORIES_QUERY = `query getCategories($site:[String], $type:[QueryArgument]) {
  entries(section:"categories"
    site: $site
    level: 1
    categoryType: $type
  ) {
    id
    title
    slug
    foreground: image { url }
    type: categoryType
  }
}`

export const ESSENTIALS_GET_SUBCATEGORIES_QUERY = `query getCategories($site: [String], $slug: [String]) {
    entries(
        section: "categories"
        slug: $slug
        limit: 100
        site: $site
        level: 1
    ) {
        order: number
        subcategories: children {
            ...baseProps
        }
    }
}

fragment baseProps on EntryInterface {
    slug
}`

export const ESSENTIALS_GET_ARTICLES_BY_CATEGORY_QUERY = `query getArticles($slug: [String], $limit: Int, $orderBy: String, $visibility: [QueryArgument], $site: [String]) {
    entries(
        section: "articles"
        relatedToEntries: {slug: $slug}
        limit: $limit
        orderBy: $orderBy
        orientationVisibility: $visibility
        site: $site
    ) {
        ...article
        visibility: orientationVisibility
    }
}

fragment article on articles_articles_Entry {
    uri
    title
    id
    readTime: text
    contentFormat
    contentType
    image { url }
}`

export const ESSENTIALS_GET_COURSES_QUERY = `query getCourses($site: [String], $slug: [String]) {
    entries(
        slug: $slug
        section: "courses"
        limit: 100
        site: $site
    ) {
        ...course
    }
}

fragment course on courses_courses_Entry {
    ...baseProps
    foreground: image {
        url
    }
    subcategories {
        ...subcourses
    }
}

fragment baseProps on EntryInterface {
    id
    uri
    slug
    title
}

fragment subcourses on subcategories_BlockType {
    id
    title: heading
}`

export const ESSENTIALS_GET_EVENTS_QUERY = `query getEvents($appEnv: [String], $site: [String]) {
    entries(relatedToCategories: {slug: $appEnv}, section: "events", limit: 100, site: $site) {
        ...event
    }
}

fragment event on events_events_Entry {
    ...baseProps
    eventType
    eventTimes {
        eventDate
        eventId
    }
    eventSeries
    eventSeriesTimes {
		eventDate
		eventId
	}
    seatCount
    facilitators {
        facilitatorName
        photo {
            ...image
        }
    }
}

fragment image on AssetInterface {
    url
}

fragment baseProps on EntryInterface {
    id
    uri
    slug
    title
}`
